import React from 'react'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    simbolos: {
        position: 'absolute',
        right: 0,
        top: -10,
        padding: 0,
        width: '72px'
    },
    card: {
        maxWidth: 800,
        borderRadius: 12,
        margin: '1rem',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}))

const LogoAssistaMais = ({ className }) => {
    const classes = useStyles();

    return (
            <div className="relative p-8 flex justify-center items-center h-full">
                <img
                    className={classes.simbolos}
                    src="/assets/images/assistamais/simbolos-do-logo.png"
                    alt=""
                />
                <img
                    className="w-200"
                    src="/assets/images/assistamais/logo-assista-mais-1.png"
                    alt=""
                />
            </div>
        
    )
}

export default LogoAssistaMais;
